import { xget, xhttp } from "../Fetchv2";
import { MGSchema } from "../schemas/mg.schema";
import { MGST } from "../schemas/mg.schema-types";
import { PGSchema } from "../schemas/pg.schema.js";

export class EEP {
	async loginwithPasswd(cred: { username: string; password?: string }) {
		let response = await xhttp<{ token: string; data: PGSchema.users }>(`/eep/users/auth`, "POST", cred);
		return response;
	}

	async getQuestions(uid = "me") {
		let response = await xget<{ eep_redactores: MGSchema.eep_redactores[]; user: PGSchema.users; history: MGSchema.eep_redactores_history[] }>(`/eep/users/${uid}/questions`);
		return response;
	}
	async editQuestions(eep_redactores: MGSchema.eep_redactores[]) {
		let response = await xhttp<{ ok: number }>(`/eep/users/me/questions`, "POST", eep_redactores);
		return response;
	}

	async deleteQuestions(eep_redactores: MGSchema.eep_redactores[]) {
		let response = await xhttp<{ ok: number }>(`/eep/users/me/questions`, "DELETE", eep_redactores);
		return response;
	}
	async sendQuestions(eep_redactores: MGSchema.eep_redactores[], question: number) {
		let response = await xhttp<{ ok: number }>(`/eep/questions`, "POST", { eep_redactores, question });
		return response;
	}

	async getUsers(status: MGST.eep_redactores.status) {
		let response = await xget<{ data: PGSchema.users[] }>(`/eep/admin/users`, { status });
		return response;
	}

	async admin_editQuestions(eep_redactores: MGSchema.eep_redactores[]) {
		let response = await xhttp<{ ok: number }>(`/eep/admin/questions`, "PUT", eep_redactores);
		return response;
	}

	async sendQuestionsAdmin(eep_redactores: MGSchema.eep_redactores, question: number) {
		let response = await xhttp<{ ok: number }>(`/eep/admin/questions`, "POST", { eep_redactores, question });
		return response;
	}

	async setStatus(_id: string, status: MGST.eep_redactores.status) {
		let response = await xhttp<{ ok: number }>(`/eep/admin/users/${_id}`, "POST", { data: { status: status } });
		return response;
	}
}
